import axios from "axios";
import { useEffect, useState } from 'react';
import MarketsContext from "./context";
import useBondContracts from "../BondContractContext/useBondContracts";
import { MarketType, Token, TxType } from "./provider.interface";
import { useLocation } from 'react-router-dom';
import { useAccount } from 'wagmi';

export default function MarketsProvider(props: any) {
  const contracts: any = useBondContracts();
  const { isConnected: isActive, address: account } = useAccount();
  const location = useLocation();

  const [markets, setMarkets] = useState<MarketType[]>([]);
  const [txs, setTxs] = useState<TxType[]>([]);
  const [tokens, setTokens] = useState<Token[]>([]);
  const [closedMarkets, setClosedMarkets] = useState([]);

  const [isLoading, setIsLoading] = useState({
    markets: false,
    tokens: false,
    txs: false,
  });

  const handleLoading = (value: any) => {
    setIsLoading((state) => ({
      ...state, ...value
    }))
  }

  useEffect(() => {
    if (!tokens.length) {
      handleLoading({ tokens: true });
      axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/tokens`)
        .then((res) => setTokens(res.data))
        .finally(() => handleLoading({ tokens: false }));
    }
  }, []);

  useEffect(() => {
    if (!markets.length || location.pathname === '/') {
      handleLoading({ markets: true, closedMarkets: true });

      axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/live-markets`)
        .then((res) => setMarkets(res.data))
        .finally(() => handleLoading({ markets: false }));

      // axios.get(`${process.env.REACT_APP_BACKEND_URL}/v2/api/closed-markets`)
      //   .then((res) => setClosedMarkets(res.data))
      //   .finally(() => handleLoading({ closedMarkets: false }));
    }
  }, [location]);

  useEffect(() => {
    const versions = ['v1', 'v2'];
    if (contracts && account) {
      Promise.all(versions.map(async (el) => {
        return axios.get(`${process.env.REACT_APP_BACKEND_URL}/${el}/api/transactions/bonded/${account}`)
          .then((res: any) => res.data.map((tx: TxType) => ({ ...tx, version: el })))
      }))
        .then((res) => {
          setTxs([...res[0], ...res[1]])
          handleLoading({ txs: false });
        })
    }
  }, [contracts, isActive, account]);

  return (
    <MarketsContext.Provider value={{markets, txs, tokens, isLoading, closedMarkets}} {...props} />
  )
}
